(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5089],{

/***/ 9068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/grailed-seller-verification/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-05-15",
      tag: "Grailed",
      title: "Grailed Seller's Profile Verification: Why It Matters and How To Do It",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["As one of the largest online marketplaces for high-quality menswear, Grailed has accumulated seven million users. Naturally, competition is tough for sellers when millions of listings are out there. Beyond ensuring your listings are attractive enough, building your profile is crucial to attracting potential customers. It is not only the product that people look for but also the person behind the seller's account. Selling is all about gaining the buyer's confidence in you. But with the proliferation of fake accounts online, how do you ensure that people will trust you? How do you build a trustworthy profile on Grailed?", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Why the need to verify? "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Online marketplaces have been convenient sources of income for millions across the globe. At first, it seems easy to navigate as it primarily involves sourcing items to sell, posting them online, and waiting for a customer to transact with you. While all these are exciting, online selling comes with many factors, like attracting people to buy from you in the first place."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For users to purchase from you, they have to trust that you are indeed selling what you posted and you will ship these in the condition you described in the listing."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This is where curating your profile and building a good relationship with every user you encounter enters the picture. As people look for menswear and accessories of high quality and sometimes, designers, on Grailed, all the more you should appear trustworthy."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Buyers would only want to buy authentic ones or exactly how they are described on the listing. To help people decide, they usually check for the seller's profile. If they see that you have a high rating and/or received mostly positive reviews, they would definitely flock to you. Nothing beats having a good first impression when it comes to online selling, where you compete with millions of other sellers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What do buyers look for from your profile? "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["There are six main aspects that customers check on your seller profile. These are feedback rating, reviews, badges, following, transaction history, and the number of your listings.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Ratings and reviews are what buyers initially check and read on the seller's profile. When you have a high rating and good feedback, people trust you. This is because you have proven to be a trustworthy seller, given your previous transactions with other customers. But be it neutral or even negative, comments generally give people an idea of how you work or transact with people.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "All about \"Seller Badges\" "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed automatically awards these to sellers who meet specific criteria for the seller badges. \"Speedy Shipper\" means you have already packed and sent for shipping the orders within three days for about 95% of transactions. \"Quick Responder\" means you address inquiries and/or reply to buyers' concerns within 12 hours for about 90% of the time. Lastly, \"Trusted Seller\" means you have a feedback score of 4.8 or above. You earn this badge when you have proven that your listings are accurate and you delivered these to your customers in good condition.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The number of followers matters for most Grailed users as well. This is another sign that users like what you put on the website/app\u2014some users like how you build an excellent seller-buyer relationship with them. The more users follow you, the more you gain popularity, and naturally, buyers would flock to your account.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Your transaction history backs up this kind of following. If you have proven yourself to be a great seller with good items and an effective communicator, then people would prefer transacting with you rather than new or unknown sellers.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["However, if you are new to Grailed, don't get discouraged if you have a small number of following. You only need to work hard and earn the trust of more users, and eventually, your followers will increase in number.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "5-star Scale Ratings "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["User feedback strongly impacts how fast you close sales on Grailed. To help buyers decide whether or not to purchase from you, Grailed implemented a 5-star scale of rating for sellers. The three main criteria consist of your speed of response to inquiries and shipping of packages, the accuracy of your listings, and your cleanliness in packing the orders.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Speed of responses "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["When a seller is highly responsive to their inquiries about the items, buyers are more likely to buy from them. No one would want to purchase from someone who barely replies to their messages, especially if it takes them days or, worse, they receive no response at all. This can be a frustrating experience for the buyer, so you want to avoid this at all costs. As much as possible, address any question or concerns a potential customer has, and who knows, they can be your actual client and a repeat buyer.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Accuracy of listings "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Make a good impression with your listings first and foremost. After all, this is what Grailed users came for in the website/app.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["State only the most important details about the items you sell. These include the brand, the type, model, sizes, material, quantity, and quality. It is also strongly recommended to indicate the item's condition, especially if these are second-hand or pre-loved clothes. The more honest and accurate you are about the items, the more buyers will trust you and will keep transacting with you in the future.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Cleanliness and speed of shipping "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The overall appearance of the packed order matters to buyers. If they receive their orders in excellent condition, the buyer will be satisfied and give you a high rating. For example, the items are in a box or a paper bag, tightly secured with a bubble wrap or other packaging materials, and for clothes, neatly folded and without any stains.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["No buyer would want to receive their orders, no matter the type and value, to be in a messy condition. If you don't take good care in packing the items, they might get damaged during shipping. You no longer have control over the orders once you ship them to the courier, so you have to ensure they are secured.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The speed of the shipping matters as well. Buyers typically want their orders to arrive in the shortest time possible. So, as soon as they have paid for their order, start packing them up. If you have bulk orders, better do it by batch to save you time and effort.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Building your seller profile "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Managing your business can be quite challenging as you have to take care of different aspects of selling. This is why you should opt to subscribe to a service like OneShop. While cross-posting your listings and delisting them will be available on Grailed soon, you can also use the app's other features.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Firstly, you would definitely want to track your performance as a seller. OneShop helps you with this by letting you set goals and monitor your progress. Simply reviewing the user feedback you received is not enough; you also have to know to evaluate yourself and identify strategies to improve your services.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Apart from tracking performance and sales, OneShop also allows you to order shipping supplies and schedule USPS pickup. This saves you time scouring online for packaging materials and then going through another website for package pickups. With a few clicks on OneShop, you can do these two important tasks more quickly.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["With the app's 7-day free trial, you can experience its convenience. OneShop can ultimately help you close sales faster and have repeat buyers as an all-in-one tool.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "Register now"
        }), " and experience all of OneShop's amazing features."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/grailed-seller-verification.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Grailed Seller's Profile Verification: Why It Matters and How To Do It"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Part of selling on marketplaces is gaining the trust of potential buyers\u2013and doing this entails building up a great profile and relationship with customers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/grailed-seller-verification"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/grailed-seller-verification"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Grailed Seller's Profile Verification: Why It Matters and How To Do It"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Part of selling on marketplaces is gaining the trust of potential buyers\u2013and doing this entails building up a great profile and relationship with customers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Grailed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 58208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/grailed-seller-verification",
      function () {
        return __webpack_require__(9068);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(58208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);